import { useResponsive } from '../../hooks/useResponsive';
import { typography } from '../../utils/styling';

const RainbowText = ({ text }: { text: string }) => {
  const { isMobile } = useResponsive();
  return (
    <span style={{
      fontSize: isMobile ? 36 : 64,
      fontWeight: '300',
      fontFamily: typography.fontFamily.body,
      backgroundImage: "linear-gradient(to right, #00A4EF 0%, #9933FF 28%, #FF00FF 54%, #00B3C2 78%, #00FF33 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      display: "inline-block",
      marginTop: isMobile ? -10 : 0,
    }}>
      {text}
    </span>
  );
};

export default RainbowText;